import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import { useState } from "react"

import { gsap, Linear } from "gsap"
import "../components/css/index.scss"
import { useLocation } from "@reach/router"
import GlobalContext from "../context/GlobalContext"

const Header = ({ siteTitle }) => {
  const location = useLocation()

  const OnMenuToggle = () => {
    // document.body.style.overflowY="hidden"
    document.querySelector("html").style.overflowY = "hidden"

    const menuTimeline = gsap.timeline()

    menuTimeline
      .to(".mainMenu", { y: 0, duration: 0.2 })
      .to(
        "ul.mainLinks li a",
        { ease: Linear.easeNone, duration: 0.32, y: 0, stagger: 0.1 },
        "-=0.15"
      )
      .to(
        "ul.other-links li a",
        { ease: Linear.easeNone, duration: 0.2, y: 0, stagger: 0.001 },
        "-=0.25"
      )
      .to(
        ".socials-box h6",
        { ease: Linear.easeNone, duration: 0.25, y: 0, stagger: 0.001 },
        "-=0.20"
      )
  }

  const glblContext = React.useContext(GlobalContext)
  const { headerVisible } = glblContext

  const [activeMenuIndex, setActiveMenuIndex] = useState(null)

  // const toggleMenu = index => {
  //   if (activeMenuIndex === index) {
  //     // If the clicked menu is already open, close it
  //     setActiveMenuIndex(null)
  //   } else {
  //     // Open the clicked menu and close the previously open menu (if any)
  //     setActiveMenuIndex(index)
  //   }
  // }

  return (
    <header
      id="Header_Main"
      className={
        (location.pathname === "/" && !headerVisible) ||
        (location.pathname === "/technology/" && headerVisible)
          ? "header"
          : "header sub"
      }
      style={{
        position:
          location.pathname === "/technology/" || location.pathname === "/"
            ? "fixed"
            : "relative",
      }}
    >
      <Container>
        <Row className="align-items-center">
          <Col md={12}>
            <ul className="main-menu">
              <li>
                <Link to="/">
                  {/* <StaticImage src="../images/logo.png" alt="logo" placeholder="tracedSVG" />   */}
                  {/* <StaticImage src="../images/temp-logo.png" alt="logo" placeholder="tracedSVG" className="temp__logo"/>   */}
                  <div className="main__logo">
                    <svg
                      width="225"
                      height="72"
                      viewBox="0 0 225 72"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M66.3492 19.1477C64.6545 19.8492 63.8454 21.7958 64.5488 23.4944C65.2485 25.1936 67.1911 26.0013 68.8894 25.3002C70.5841 24.5984 71.3932 22.6517 70.6898 20.9532C69.9901 19.2543 68.0475 18.4455 66.3492 19.1477Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M68.8688 45.8082C67.1741 45.1031 65.2279 45.9075 64.5245 47.6056C63.8211 49.3034 64.6229 51.2505 66.3177 51.956C68.016 52.6607 69.9585 51.8563 70.6619 50.1585C71.369 48.4607 70.5635 46.513 68.8688 45.8082Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M47.4821 64.6356C45.7837 65.3374 44.9783 67.2834 45.678 68.9829C46.3778 70.6815 48.3239 71.4899 50.0186 70.788C51.717 70.0862 52.5224 68.1402 51.8227 66.441C51.1229 64.7425 49.1768 63.9341 47.4821 64.6356Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23.4018 64.6127C21.7071 63.908 19.7645 64.712 19.0611 66.4102C18.3541 68.1076 19.1596 70.0554 20.8543 70.7605C22.549 71.4656 24.4951 70.6608 25.1985 68.9626C25.9019 67.266 25.1001 65.3178 23.4018 64.6127Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.05631 45.741C0.357965 46.4432 -0.447476 48.3899 0.252273 50.0888C0.952023 51.7877 2.89819 52.5953 4.59289 51.8942C6.29124 51.1924 7.09668 49.2465 6.39693 47.5468C5.69718 45.8476 3.75102 45.0399 2.05631 45.741Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.62652 19.0856C2.93182 18.3802 0.98564 19.1853 0.282246 20.8827C-0.421147 22.5801 0.380641 24.5275 2.07899 25.2334C3.77369 25.9381 5.71624 25.1337 6.41964 23.436C7.12667 21.7385 6.32123 19.7904 4.62652 19.0856Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.9249 0.252896C19.2302 0.954347 18.4212 2.90067 19.1209 4.59956C19.8243 6.2988 21.7668 7.10719 23.4615 6.40537C25.1599 5.70319 25.969 3.75723 25.2656 2.05834C24.5658 0.359098 22.6233 -0.448554 20.9249 0.252896Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M50.0874 0.281246C48.3927 -0.424584 46.4501 0.380149 45.7467 2.07794C45.0397 3.775 45.8451 5.72278 47.5398 6.42788C49.2345 7.13335 51.1807 6.32898 51.8841 4.63119C52.5875 2.9334 51.7857 0.985981 50.0874 0.281246Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M50.8413 23.8624C54.1177 23.8628 55.601 19.9023 53.3925 17.6892C51.1802 15.4768 47.226 16.9629 47.226 20.245C47.226 25.0832 41.8612 27.8558 37.5133 28.5456C36.8172 28.6562 34.3025 28.5511 33.5444 28.431C29.1965 27.7405 23.8317 24.969 23.8317 20.1293C23.8317 16.8472 19.8738 15.3618 17.6652 17.5738C15.4566 19.7873 16.9399 23.7478 20.2164 23.7475C25.049 23.7486 27.8152 29.1204 28.5077 33.4736C28.617 34.1696 28.5113 36.6929 28.391 37.4509C27.7022 41.8045 24.936 47.1767 20.1034 47.1771C16.8233 47.1771 15.34 51.1373 17.5486 53.3504C19.7608 55.5628 23.7151 54.0777 23.7151 50.7949C23.7151 45.9563 29.0798 43.1844 33.4278 42.4939C34.1239 42.3837 36.6422 42.4888 37.4003 42.6085C41.7482 43.2994 47.113 46.0713 47.113 50.9106C47.113 54.1923 51.0673 55.6781 53.2759 53.4653C55.4845 51.2519 54.0048 47.2917 50.7247 47.2924C45.8921 47.2917 43.1259 41.9191 42.437 37.5655C42.3241 36.8703 42.4297 34.347 42.55 33.5893C43.2388 29.2354 46.0087 23.8628 50.8413 23.8624Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M35.473 9.8418C32.7104 9.8418 30.4727 12.0834 30.4727 14.8472C30.4727 17.6114 32.7104 19.8526 35.473 19.8526C38.2319 19.8526 40.4696 17.6114 40.4696 14.8472C40.4696 12.0834 38.2319 9.8418 35.473 9.8418Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M56.1157 30.5156C53.3568 30.5156 51.1191 32.7561 51.1191 35.521C51.1191 38.2856 53.3568 40.5264 56.1157 40.5264C58.8783 40.5264 61.116 38.2856 61.116 35.521C61.116 32.7561 58.8783 30.5156 56.1157 30.5156Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M35.473 51.1895C32.7141 51.1895 30.4727 53.4307 30.4727 56.1949C30.4727 58.9591 32.7141 61.2004 35.473 61.2004C38.2319 61.2004 40.4696 58.9591 40.4696 56.1949C40.4696 53.4307 38.2319 51.1895 35.473 51.1895Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.8267 30.5156C12.0678 30.5156 9.83008 32.7569 9.83008 35.521C9.83008 38.2849 12.0678 40.5268 14.8267 40.5268C17.5893 40.5268 19.827 38.2849 19.827 35.521C19.827 32.7569 17.5893 30.5156 14.8267 30.5156Z"
                        fill="#F68521"
                      />
                      <path
                        d="M89.7973 25.7275V30.8256H101.379V35.3646H89.7973V40.7543H104.583V45.4598H84.3633V21.002H104.583V25.7275H89.7973Z"
                        fill="#CBD5E4"
                      />
                      <path
                        d="M118.909 40.7522C121.383 40.7522 123.217 40.1351 124.408 38.9015C125.604 37.6676 126.198 35.7771 126.198 33.2297C126.198 30.6827 125.604 28.7947 124.408 27.5667C123.217 26.3389 121.383 25.7247 118.909 25.7247H113.916V40.7522H118.909ZM118.909 21C123.278 21 126.518 22.0007 128.625 24.0017C130.732 26.0035 131.785 29.079 131.785 33.2297C131.785 37.3808 130.732 40.4563 128.625 42.4577C126.518 44.4591 123.278 45.4595 118.909 45.4595H108.482V21H118.909Z"
                        fill="#CBD5E4"
                      />
                      <path
                        d="M157.436 33.4373V45.4598H147.781C143.342 45.4598 140.048 44.4594 137.908 42.4591C135.773 40.4587 134.701 37.3814 134.701 33.2307C134.701 29.0804 135.773 26.0031 137.908 24.0027C140.048 22.0024 143.342 21.002 147.781 21.002H156.397V25.7275H147.781C145.238 25.7275 143.353 26.3388 142.125 27.5658C140.897 28.7968 140.288 30.684 140.288 33.2307C140.288 35.7778 140.897 37.669 142.125 38.904C143.353 40.135 145.238 40.7543 147.781 40.7543H152.005V33.4373H157.436Z"
                        fill="#CBD5E4"
                      />
                      <path
                        d="M181.915 25.5534H181.547L181.572 25.7275H167.129V30.8256H178.715V35.3646H167.129V40.7543H181.915V45.4598H161.695V21.002H181.915V25.5534Z"
                        fill="#CBD5E4"
                      />
                      <path
                        d="M224.068 49.7949H217.286L209.785 44.0453H196.439C193.017 44.0453 190.229 41.2552 190.229 37.829V27.2163C190.229 23.7901 193.017 21 196.439 21H215.391C218.813 21 221.601 23.7901 221.601 27.2163V37.829C221.601 39.745 220.73 41.4603 219.363 42.6008L215.456 39.6082C216.408 39.5728 217.169 38.7896 217.169 37.829V27.2163C217.169 26.2357 216.371 25.4346 215.391 25.4346H196.439C195.459 25.4346 194.657 26.2357 194.657 27.2163V37.829C194.657 38.8126 195.459 39.6107 196.439 39.6107H210.788L216.451 43.9541L224.068 49.7949Z"
                        fill="#F68521"
                      />
                    </svg>
                  </div>

                  <div className="temp__logo">
                    <svg
                      width="225"
                      height="72"
                      viewBox="0 0 225 72"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M66.3511 19.1477C64.6564 19.8492 63.8473 21.7958 64.5507 23.4944C65.2504 25.1936 67.193 26.0013 68.8913 25.3002C70.586 24.5984 71.3951 22.6517 70.6917 20.9532C69.992 19.2543 68.0494 18.4455 66.3511 19.1477Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M68.8688 45.8082C67.1741 45.1031 65.2279 45.9075 64.5245 47.6056C63.8211 49.3034 64.6229 51.2505 66.3177 51.956C68.016 52.6607 69.9585 51.8563 70.6619 50.1585C71.369 48.4607 70.5635 46.513 68.8688 45.8082Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M47.4821 64.6376C45.7837 65.3394 44.9783 67.2854 45.678 68.9849C46.3778 70.6835 48.3239 71.4919 50.0186 70.79C51.717 70.0882 52.5224 68.1422 51.8227 66.443C51.1229 64.7445 49.1768 63.9361 47.4821 64.6376Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23.4018 64.6127C21.7071 63.908 19.7645 64.712 19.0611 66.4102C18.3541 68.1076 19.1596 70.0554 20.8543 70.7605C22.549 71.4656 24.4951 70.6608 25.1985 68.9626C25.9019 67.266 25.1001 65.3178 23.4018 64.6127Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.05631 45.741C0.357965 46.4432 -0.447476 48.3899 0.252273 50.0888C0.952023 51.7877 2.89819 52.5953 4.59289 51.8942C6.29124 51.1924 7.09668 49.2465 6.39693 47.5468C5.69718 45.8476 3.75102 45.0399 2.05631 45.741Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.62652 19.0856C2.93182 18.3802 0.98564 19.1853 0.282246 20.8827C-0.421147 22.5801 0.380641 24.5275 2.07899 25.2334C3.77369 25.9381 5.71624 25.1337 6.41964 23.436C7.12667 21.7385 6.32123 19.7904 4.62652 19.0856Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.923 0.252896C19.2283 0.954347 18.4193 2.90067 19.119 4.59956C19.8224 6.2988 21.7649 7.10719 23.4596 6.40537C25.158 5.70319 25.9671 3.75723 25.2637 2.05834C24.5639 0.359098 22.6214 -0.448554 20.923 0.252896Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M50.0894 0.283199C48.3947 -0.422631 46.4521 0.382102 45.7487 2.07989C45.0417 3.77695 45.8471 5.72473 47.5418 6.42983C49.2365 7.1353 51.1827 6.33093 51.8861 4.63314C52.5895 2.93535 51.7877 0.987934 50.0894 0.283199Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M50.8413 23.8643C54.1177 23.8647 55.601 19.9042 53.3925 17.6911C51.1802 15.4787 47.226 16.9648 47.226 20.2469C47.226 25.0851 41.8612 27.8577 37.5133 28.5475C36.8172 28.6581 34.3025 28.553 33.5444 28.4329C29.1965 27.7424 23.8317 24.9709 23.8317 20.1312C23.8317 16.8491 19.8738 15.3637 17.6652 17.5757C15.4566 19.7892 16.9399 23.7497 20.2164 23.7494C25.049 23.7505 27.8152 29.1223 28.5077 33.4755C28.617 34.1715 28.5113 36.6948 28.391 37.4528C27.7022 41.8064 24.936 47.1786 20.1034 47.179C16.8233 47.179 15.34 51.1392 17.5486 53.3523C19.7608 55.5647 23.7151 54.0796 23.7151 50.7968C23.7151 45.9582 29.0798 43.1863 33.4278 42.4958C34.1239 42.3856 36.6422 42.4907 37.4003 42.6104C41.7482 43.3013 47.113 46.0732 47.113 50.9125C47.113 54.1942 51.0673 55.68 53.2759 53.4672C55.4845 51.2538 54.0048 47.2936 50.7247 47.2943C45.8921 47.2936 43.1259 41.921 42.437 37.5674C42.3241 36.8722 42.4297 34.3489 42.55 33.5912C43.2388 29.2373 46.0087 23.8647 50.8413 23.8643Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M35.473 9.84375C32.7104 9.84375 30.4727 12.0854 30.4727 14.8492C30.4727 17.6134 32.7104 19.8546 35.473 19.8546C38.2319 19.8546 40.4696 17.6134 40.4696 14.8492C40.4696 12.0854 38.2319 9.84375 35.473 9.84375Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M56.1138 30.5156C53.3549 30.5156 51.1172 32.7561 51.1172 35.521C51.1172 38.2856 53.3549 40.5264 56.1138 40.5264C58.8764 40.5264 61.1141 38.2856 61.1141 35.521C61.1141 32.7561 58.8764 30.5156 56.1138 30.5156Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M35.473 51.1895C32.7141 51.1895 30.4727 53.4307 30.4727 56.1949C30.4727 58.9591 32.7141 61.2004 35.473 61.2004C38.2319 61.2004 40.4696 58.9591 40.4696 56.1949C40.4696 53.4307 38.2319 51.1895 35.473 51.1895Z"
                        fill="#F68521"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.8248 30.5176C12.0659 30.5176 9.82812 32.7589 9.82812 35.523C9.82812 38.2869 12.0659 40.5288 14.8248 40.5288C17.5874 40.5288 19.8251 38.2869 19.8251 35.523C19.8251 32.7589 17.5874 30.5176 14.8248 30.5176Z"
                        fill="#F68521"
                      />
                      <path
                        d="M90.434 29.7275V34.8256H102.016V39.3646H90.434V44.7543H105.22V49.4598H85V25.002H105.22V29.7275H90.434Z"
                        fill="#555555"
                      />
                      <path
                        d="M119.548 44.7522C122.022 44.7522 123.856 44.1351 125.047 42.9015C126.243 41.6676 126.837 39.7771 126.837 37.2297C126.837 34.6827 126.243 32.7947 125.047 31.5667C123.856 30.3389 122.022 29.7247 119.548 29.7247H114.555V44.7522H119.548ZM119.548 25C123.917 25 127.157 26.0007 129.264 28.0017C131.371 30.0035 132.424 33.079 132.424 37.2297C132.424 41.3808 131.371 44.4563 129.264 46.4577C127.157 48.4591 123.917 49.4595 119.548 49.4595H109.121V25H119.548Z"
                        fill="#555555"
                      />
                      <path
                        d="M158.075 37.4373V49.4598H148.42C143.981 49.4598 140.687 48.4594 138.547 46.4591C136.412 44.4587 135.34 41.3814 135.34 37.2307C135.34 33.0804 136.412 30.0031 138.547 28.0027C140.687 26.0024 143.981 25.002 148.42 25.002H157.036V29.7275H148.42C145.877 29.7275 143.992 30.3388 142.764 31.5658C141.536 32.7968 140.927 34.684 140.927 37.2307C140.927 39.7778 141.536 41.669 142.764 42.904C143.992 44.135 145.877 44.7543 148.42 44.7543H152.644V37.4373H158.075Z"
                        fill="#555555"
                      />
                      <path
                        d="M182.552 29.5534H182.184L182.209 29.7275H167.766V34.8256H179.352V39.3646H167.766V44.7543H182.552V49.4598H162.332V25.002H182.552V29.5534Z"
                        fill="#555555"
                      />
                      <path
                        d="M224.706 53.7949H217.924L210.423 48.0453H197.077C193.655 48.0453 190.867 45.2552 190.867 41.829V31.2163C190.867 27.7901 193.655 25 197.077 25H216.029C219.451 25 222.239 27.7901 222.239 31.2163V41.829C222.239 43.745 221.368 45.4603 220.001 46.6008L216.094 43.6082C217.046 43.5728 217.807 42.7896 217.807 41.829V31.2163C217.807 30.2357 217.009 29.4346 216.029 29.4346H197.077C196.097 29.4346 195.295 30.2357 195.295 31.2163V41.829C195.295 42.8126 196.097 43.6107 197.077 43.6107H211.426L217.089 47.9541L224.706 53.7949Z"
                        fill="#F68521"
                      />
                    </svg>
                  </div>
                </Link>
              </li>
              <div className="sub_menus">
                <li>
                  <div className="nav_div">
                    <span
                      className={activeMenuIndex === 0 ? "highlighted" : ""}
                      
                    >
                       Technology{" "}
                      <svg
                        width="19"
                        height="10"
                        viewBox="0 0 19 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.258435 0.258435C0.57169 -0.0548196 1.06188 -0.0832973 1.40731 0.173002L1.50627 0.258435L9.11765 7.86941L16.729 0.258435C17.0423 -0.0548196 17.5325 -0.0832973 17.8779 0.173002L17.9769 0.258435C18.2901 0.57169 18.3186 1.06188 18.0623 1.40731L17.9769 1.50627L9.74156 9.74156C9.42831 10.0548 8.93812 10.0833 8.59269 9.827L8.49373 9.74156L0.258435 1.50627C-0.0861451 1.16169 -0.0861451 0.603015 0.258435 0.258435Z"
                          fill="#555555"
                        />
                      </svg>
                    </span>

                    <ul
                      className={`menu-list ${
                        activeMenuIndex === 0 ? "visible" : ""
                      }`}
                    >
                      <li>
                        <Link activeClassName="activeFtr" to="/technology/">
                        Products
                        </Link>
                      </li>
                      <li>
                        <Link activeClassName="activeFtr" to="/usecase/">
                          Use Case
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <div className="nav_div company_nav">
                    <span
                      className={activeMenuIndex === 1 ? "highlighted" : ""}
                      
                    >
                      Company{" "}
                      <svg
                        width="19"
                        height="10"
                        viewBox="0 0 19 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.258435 0.258435C0.57169 -0.0548196 1.06188 -0.0832973 1.40731 0.173002L1.50627 0.258435L9.11765 7.86941L16.729 0.258435C17.0423 -0.0548196 17.5325 -0.0832973 17.8779 0.173002L17.9769 0.258435C18.2901 0.57169 18.3186 1.06188 18.0623 1.40731L17.9769 1.50627L9.74156 9.74156C9.42831 10.0548 8.93812 10.0833 8.59269 9.827L8.49373 9.74156L0.258435 1.50627C-0.0861451 1.16169 -0.0861451 0.603015 0.258435 0.258435Z"
                          fill="#555555"
                        />
                      </svg>
                    </span>

                    <ul
                      className={`menu-list ${
                        activeMenuIndex === 1 ? "visible" : ""
                      }`}
                    >                      
                      <li>
                        <Link activeClassName="activeFtr" to="/company/">
                        Leadership
                        </Link>
                      </li>

                      <li>
                        <Link activeClassName="activeFtr" to="/media/">
                        Newsroom
                        </Link>
                      </li>

                      <li>
                        <Link activeClassName="activeFtr" to="/career/">
                          Career
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <div className="nav_div">
                    <span
                      className={activeMenuIndex === 2 ? "highlighted" : ""}
                      
                    >
                      Resources{" "}
                      <svg
                        width="19"
                        height="10"
                        viewBox="0 0 19 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.258435 0.258435C0.57169 -0.0548196 1.06188 -0.0832973 1.40731 0.173002L1.50627 0.258435L9.11765 7.86941L16.729 0.258435C17.0423 -0.0548196 17.5325 -0.0832973 17.8779 0.173002L17.9769 0.258435C18.2901 0.57169 18.3186 1.06188 18.0623 1.40731L17.9769 1.50627L9.74156 9.74156C9.42831 10.0548 8.93812 10.0833 8.59269 9.827L8.49373 9.74156L0.258435 1.50627C-0.0861451 1.16169 -0.0861451 0.603015 0.258435 0.258435Z"
                          fill="#555555"
                        />
                      </svg>
                    </span>

                    <ul
                      className={`menu-list ${
                        activeMenuIndex === 2 ? "visible" : ""
                      }`}
                    >
                      <li>
                        <Link activeClassName="activeFtr" to="/blog/">
                          Blog
                          {/* <span>new</span> */}
                        </Link>
                      </li>
                      <li>
                        <Link activeClassName="activeFtr" to="/video/">
                          Videos
                          {/* <span>new</span> */}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="last_link">
               
                  <Link activeClassName="activeFtr" to="/contact/">
                    Contact Us
                  </Link>
                  
                </li>
              </div>
              <li className="mob_menu_resp">
                <div
                  onClick={OnMenuToggle}
                  className={
                    (location.pathname === "/" && !headerVisible) ||
                    (location.pathname === "/technology/" && headerVisible)
                      ? "menuBar"
                      : "menuBrownNav"
                  }
                >
                  <a href={evt => evt.preventDefault()}>
                    <span className="mB_1"></span>
                    <span></span>
                    <span></span>
                  </a>
                </div>
              </li> 
            </ul>
          </Col>
        </Row>
      </Container>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
